import {EpLayer} from "./layer";
import {
    farInventoryLocationStyle,
    inventoryLocationBeatersLineStyle,
    inventoryLocationObserversLineStyle,
    inventoryLocationStyle
} from "../styles/inventory-locations";

export class EpInventoryLocations extends EpLayer {
    constructor(map) {
        super(map);

        this.style = inventoryLocationStyle;
        this.farStyle = farInventoryLocationStyle;

        this.title = 'Obszary';
        this.name = 'locations';

        return this;
    }

    addObserversLine(coordinates) {
        let feature = this.addFeature(coordinates, {
            type: 'LineString',
            fields: {type: 'observers_line'},
        })

        feature.setStyle(inventoryLocationObserversLineStyle)

        return feature;
    }

    addBeatersLine(coordinates) {
        let feature = this.addFeature(coordinates, {
            type: 'LineString',
            fields: {type: 'beaters_line'},
        })

        feature.setStyle(inventoryLocationBeatersLineStyle)

        return feature;
    }

    addSpot(latitude, longitude, type, label) {
        let feature = this.addFeature([longitude, latitude], {
            fields: {
                type: parseInt(type) === 1 ? 'observer' : 'beater',
                name: label
            }
        })

        if(parseInt(type) === 1) {
            feature.setStyle(inventoryLocationBeatersLineStyle)
        } else {
            feature.setStyle(inventoryLocationObserversLineStyle)
        }
    }
}
